<template>
    <div id="app" class="app" ref="scrollContainer">
        <div v-if="!isMobile && isMounted">
            <header class="header">
                <img src="../../assets/logo-din-stad.png" class="logo-with-text-image" />

                <!-- <button v-if="showNewsLetterButton" class="newsletter-button" @click="showNewsLetter">
                    Få nyhetsbrev
                </button> -->
                <b-button variant="light" v-if="showScrollToTop" @click="scrollToTop" class="scroll-to-top">
                    ↑ Skrolla till början ↑
                </b-button>
                <!-- <img src="../../assets/logo-transparent.png" class="logo-image" /> -->
                <div class="search-events-container">
                    <SearchEvents></SearchEvents>
                </div>

                <!-- <div class="button-container">
                    <b-button style="border-color: #41576D; background-color: #41576D; color: white; width: 100px;"
                        @click="showLoginModal = true">Logga in</b-button>
                    <b-button variant="success" style="width: 140px;" @click="showCreateAccountModal = true">Skapa
                        konto</b-button>
                </div> -->
                <!-- 
                <div>
                    <RoundButton iconClass="fas fa-user" :size="25" iconSize="16px"
                        @click="userModalIsOpen = !userModalIsOpen" />
                    <transition name="fade-slide">
                        <div v-if="userModalIsOpen" class="menu-dropdown">
                            <div style="position: absolute; right: 5px;">
                                <RoundButton iconClass="fas fa-times" :size="25" iconSize="16px"
                                    @click="userModalIsOpen = !userModalIsOpen" :transparentBackground="true"
                                    :iconColor="'white'" />
                            </div>
                            <div style="padding: 10px;">
                                <div class="menu-section">
                                    <div style="padding-left: 5px;">
                                        <i class="fa fa-city city-icon">
                                            <span class="city-icon-text-padding">Din stad</span>
                                        </i>
                                    </div>
                                    <EventstadenDropdownList :options="[]"></EventstadenDropdownList>
                                </div>
                            </div>
                            <div class="menu-footer">
                                <hr class="divider" />
                                <div class="footer-text">För att få fler alternativ behöver ni vara inloggade, logga in
                                    här eller skapa ett nytt konto</div>
                            </div>
                        </div>
                    </transition>
                </div> -->

                <div style="margin-left: 3%;" class="news-container">
                    <button @click="showNewsLetter" class="menu-items-mobile">
                        <i class="fas fa-envelope icon"></i> <span class="icon-text">Nyhetsbrev</span>
                    </button>
                </div>
                <!-- <button v-if="showNewsLetterButton" class="newsletter-button1" @click="showNewsLetter">
                    Få nyhetsbrev
                </button> -->
                <div style="margin-left: 10px;">
                    <EventstadenDropdownList :options="[]"></EventstadenDropdownList>
                </div>
            </header>

            <!-- <div style="padding-left: 50px;">
                <MenuDropdown></MenuDropdown>
                <MenuDropdown></MenuDropdown>
                <MenuDropdown></MenuDropdown>
                <MenuDropdown></MenuDropdown>
                <MenuDropdown></MenuDropdown>
            </div> -->
        </div>

        <header class="header" v-if="isMobile">
            <b-button variant="light" v-if="showScrollToTop" @click="scrollToTop" class="scroll-to-top">
                ↑ Skrolla till början ↑
            </b-button>
            <MobileTopMenu @accountModal="toggleAccountModal" />
        </header>

        <!-- <div v-if="!isMobile">
            <header class="header">
                <img src="../../assets/logo-din-stad.png" class="logo-with-text-image" />
                <div>
                    <i class="fas fa-map-marker-alt icon"></i>
                </div>
            </header>
        </div>
        <div v-else>
            <MobileMenu @accountModal="toggleAccountModal" />
        </div> -->

        <AccountModal :visible="showLoginModal" @accounModal="toggleAccountModal" />
        <CreateAccountModal :visible="showCreateAccountModal" @accounModal="toggleAccountModal" />
        <ForgotPasswordModal v-if="forgotPasswordModal" @close="forgotPasswordModal = false" />
        <!-- @hidden="hideNewsLetter" -->
        <b-modal v-model="showNewsLetterModal" size="lg" hide-header hide-footer class="custom-modal">
            <NewsLetter :isMobile="isMobile" @close="hideNewsLetter"></NewsLetter>
        </b-modal>

        <main v-if="!showAllTitle" :style="{ marginTop: isMobile ? '80px' : '84px' }">
            <PromotionCarousel></PromotionCarousel>

            <div v-if="selectedCity">
                <NetflixScroll :title="'Händer i ' + selectedCity" :apiUrl="cityApiUrl" :key="cityNetflixKey"
                    @show-all-events="handleShowAllCityEvents"></NetflixScroll>
            </div>

            <NetflixScroll :title="'Utvalda evenemang'" :apiUrl="'events/sponsored?PageSize=10&PageNumber='"
                @show-all-events="handleShowAllEvents"></NetflixScroll>

            <NetflixScroll :title="'Populärt just nu'" :apiUrl="'events/popular?PageSize=10&PageNumber='"
                @show-all-events="handleShowAllEvents"></NetflixScroll>

            <div style="margin-top: 5%; margin-bottom: 1%;">
                <LargeEventCard :event-story="eventStories[0]" :event-story2="eventStories[1]"></LargeEventCard>
            </div>

            <div style="padding-top: 60px; position: relative; left: 10px; padding-right: 10px;">
                <EventlyScroll v-if="isMounted" :title="listTitle" :apiUrl="listApiUrl" :isMobile="isMobile">
                </EventlyScroll>
            </div>
        </main>
        <main v-if="showAllTitle" style="margin-top: 125px;">
            <div class="close-view-all-events" @click="closeViewAllEvents"><i class="fa-solid fa-x"></i></div>
            <EventlyScroll v-if="isMounted" :title="listTitle" :apiUrl="showMoreListApi" :isMobile="isMobile">
            </EventlyScroll>
        </main>
        <div>
            <EventstadenFotter :isMobile="isMobile" />
        </diV>
    </div>
</template>

<script>
import PromotionCarousel from "../../components/PromotionCarousel.vue";
import LargeEventCard from "../../components/LargeEventCard.vue";
import NetflixScroll from "../../components/NetflixScoll.vue";
import EventstadenFotter from "../../components/EventstadenFotter.vue";
// import MenuDropdown from "../../components/MenuDropdown.vue";
import FilterMenu from "../../components/Search/FilterMenu.vue";
import EventstadenDropdownList from "../../components/EventstadenDropdownList.vue";
import AccountModal from "../../components/AccountModal.vue";
import ForgotPasswordModal from "../../components/ForgotPasswordModal.vue";
import CreateAccountModal from "../../components/CreateAccountModal.vue";
import MobileTopMenu from "../../components/mobile/MobileTopMenu.vue";
import EventlyScroll from "../../components/EventlyScroll2.vue";
import ApiConfig from "../generals/models/ApiConfig.js"
import { toRaw } from "vue";
import EventBusMixin, { EventBus } from '../../api/EventBusMixin';
import SearchEvents from "../../components/Search/SearchEvents.vue";
import RoundButton from "../../components/Buttons/circleButton.vue";
import localStorageService from "../../localStorageService/localStorageService.js";
import EventStoryResponse from "../../aggrigates/events/models/EventStoryResponse.js";
import AxiosInstance from "../../api/axios";
import NewsLetter from "../eventstaden/mailchimpSubscribe .vue"
// import { event } from 'vue-gtag'

/* eslint-disable vue/no-unused-components */


export default {
    name: "App",
    mixins: [EventBusMixin],
    components: {
        ApiConfig,
        PromotionCarousel,
        LargeEventCard,
        NetflixScroll,
        EventstadenFotter,
        // MenuDropdown, 
        RoundButton,
        FilterMenu,
        EventstadenDropdownList,
        AccountModal,
        ForgotPasswordModal,
        CreateAccountModal,
        MobileTopMenu,
        EventlyScroll,
        SearchEvents,
        NewsLetter
    },
    data() {
        return {
            isMounted: false,
            // categories: ListResponse,
            isMobile: false,
            showFilterMenu: false,
            showLoginModal: false,
            forgotPasswordModal: false,
            showCreateAccountModal: false,
            showAllTitle: false,
            listTitle: null,
            listApiUrl: null,
            userModalIsOpen: false,
            selectedCity: null,
            cityApiUrl: '',
            cityCacheName: null,
            cityNetflixKey: 0,
            pageNumber: 0,
            eventStories: [],
            showNewsLetterModal: false,
            showNewsLetterButton: true,
            scrollPosition: 0,
            showScrollToTop: false,
            showMoreListApi: null
        };
    },
    async mounted() {
        this.openNewsLetterByUrl();
        this.$gtag.pageview({ page_path: 'Viewing MainFlow' })
        await this.getEventStories();
        EventBus.on('accountModal', this.toggleAccountModal);
        EventBus.on('showNewsLetter', this.showNewsLetter);
        EventBus.on('city-was-changed', this.cityFilterWasChanged);
        this.listTitle = 'Alla evenemang';
        this.listApiUrl = 'events?PageSize=40&PageNumber=';
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        this.isMounted = true;
        this.cityFilterWasChanged();
        this.showSubscribeView();
        this.restoreScrollPosition();
        this.watchScroll();
    },

    getApiConfig() {
        return toRaw(this.apiConfig);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
        EventBus.off('accountModal', this.toggleAccountModal);
        EventBus.off('city-was-changed', this.cityFilterWasChanged);
        EventBus.off('showNewsLetter', this.showNewsLetter);
        const container = this.$refs.scrollContainer;
        if (container) {
            container.removeEventListener('scroll', () => { });
        }
    },
    methods: {
        openNewsLetterByUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('newsletter') === '1') {
                this.showNewsLetter();
                // Remove the query param from URL without reload
                urlParams.delete('newsletter');
                const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
                window.history.replaceState({}, '', newUrl);
            }
        },
        scrollToTop() {
            const container = this.$refs.scrollContainer;
            if (container) {
                container.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
        },
        watchScroll() {
            const container = this.$refs.scrollContainer;
            if (container) {
                container.addEventListener('scroll', () => {
                    this.scrollPosition = container.scrollTop;
                    this.showScrollToTop = this.scrollPosition > 600;
                    localStorage.setItem('scrollPosition', this.scrollPosition);
                });
            }
        },
        restoreScrollPosition() {
            this.$nextTick(() => {
                // Check if we are navigating back (you can set this flag when needed)
                const isNavigatingBack = sessionStorage.getItem('isNavigatingBack');
                if (!isNavigatingBack) {
                    // If navigating back, reset the scroll position to 0 with smooth scrolling
                    const container = this.$refs.scrollContainer;
                    if (container) {
                        setTimeout(() => {
                            container.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }, 1000); // Adjust this timeout if needed
                    }
                    // Reset the flag for the next navigation
                    sessionStorage.removeItem('isNavigatingBack');
                } else {
                    // Restore scroll position from localStorage if not navigating back
                    const savedPosition = localStorage.getItem('scrollPosition');
                    if (savedPosition) {
                        const container = this.$refs.scrollContainer;
                        if (container) {
                            setTimeout(() => {
                                container.scrollTo({
                                    top: parseInt(savedPosition, 10),
                                    behavior: 'smooth'
                                });
                                sessionStorage.setItem('isNavigatingBack', 'false');
                            }, 1000); // Adjust this timeout if needed
                        }
                    }
                }
            });
        },
        showSubscribeView() {
            const hideSubscribe = localStorageService.get("hide-subscribe");
            if (hideSubscribe) {
                this.showNewsLetterButton = !hideSubscribe;
            }
        },
        async getEventStories() {
            try {
                const eventResponse = new EventStoryResponse();
                const response = await AxiosInstance.get("events/stories?" + this.pageNumber);
                console.dir(response);
                eventResponse.fromResponse(response.data);

                if (eventResponse.items.length === 0) {
                    this.allEventsIsLoaded = true;
                    return;
                }

                this.pageNumber++;

                this.eventStories = toRaw(eventResponse.items);
            } catch (error) {
                console.error("Error fetching events:", error);

            }
        },

        handleShowAllEvents(payload) {
            const { title, endPoint } = payload;
            this.listTitle = title;
            this.showMoreListApi = endPoint;
            this.showAllTitle = true;
        },

        handleShowAllCityEvents(payload) {
            const { title } = payload;
            this.listTitle = title;
            this.showMoreListApi = 'events/city/' + this.selectedCity + '?PageSize=30&PageNumber=';
            this.showAllTitle = true;
        },

        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        toggleFilterMenu() {
            this.showFilterMenu = !this.showFilterMenu;
        },
        closeFilterMenu() {
            this.showFilterMenu = false; // Hide the FilterMenu
        },
        cityFilterWasChanged() {
            this.selectedCity = localStorageService.get("selected-city");
            this.cityCacheName = "netflix-" + this.selectedCity;
            // this.cityApiUrl = "events?PageSize=6&PageNumber=";
            this.cityApiUrl = 'events/city/' + this.selectedCity + '?PageSize=10&PageNumber=';
            this.netflixKey++;
        },
        toggleAccountModal(payload) {
            if (payload.open == "forgot-password") {
                this.forgotPasswordModal = true;
                this.showLoginModal = false;
                this.showCreateAccountModal = false;
            }
            else if (payload.open == "create-account") {
                this.forgotPasswordModal = false;
                this.showLoginModal = false;
                this.showCreateAccountModal = true;
            }
            else if (payload.open == "login-account") {
                this.showLoginModal = true;
                this.forgotPasswordModal = false;
                this.showCreateAccountModal = false;
            }
            else {
                this.forgotPasswordModal = false;
                this.showLoginModal = false;
                this.showCreateAccountModal = false;
            }
        },
        closeViewAllEvents() {
            this.listTitle = 'Alla evenemang',
                this.listApiUrl = 'events?PageSize=40&PageNumber=';
            this.showAllTitle = false;
        },
        showNewsLetter() {
            this.showNewsLetterModal = true;
            this.showNewsLetterButton = false;
        },
        hideNewsLetter() {
            this.showNewsLetterModal = false;
            this.showNewsLetterButton = true;
            this.showSubscribeView();
        }
    }
};
</script>

<style scoped>
.news-container {
    position: relative;
    top: 3px;
}

.icon {
    color: white !important;
    font-size: 23px !important;
}

.icon-text {
    position: relative;
    bottom: 4px;
    color: white !important;
    font-size: 14px !important;
}

.menu-items-mobile {
    background-color: transparent;
    border: none;
}

.app {
    max-height: 100vh;
    overflow: auto;
}

.city-icon {
    font-size: 14px;
}

.city-icon-text-padding {
    padding-left: 10px;
    font-size: 12px;
}

.menu-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    background-color: #15244d;
    /* Background for footer */
    padding: 10px 0;
}

.divider {
    margin: 0 auto;
    width: 100%;
    border: none;
    border-top: 1px solid white;
}

.footer-text {
    text-align: left;
    margin: 10px;
    font-size: 12px;
    color: white;
}

.menu-dropdown {
    position: absolute;
    top: 70px;
    right: 5px;
    background: #15244d;
    color: #fff;
    width: 23rem;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    padding: 10px;
    display: flex;
    justify-content: space-between;
    z-index: 1000;
    min-height: 200px;
}

/* html,
body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
} */

/* Transparent scrollbar styling */
.app {
    max-height: 100vh;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    overflow-x: hidden;
    /* Hide horizontal overflow */
}

/* .app::-webkit-scrollbar {
    width: 8px;
}

.app::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
}

.app::-webkit-scrollbar-track {
    background-color: transparent;
}

.app:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
} */

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.9);
    /* Ensures visibility */
    z-index: 1000;
    /* Keeps it on top */
    padding: 20px;
}

.search-events-container {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    /* align-items: end;     */
}

.nav a {
    margin: 0 15px;
    color: white;
    text-decoration: none;
}

.actions .search-bar {
    padding: 10px;
    margin-right: 10px;
}

.actions button {
    margin-left: 10px;
}

.content-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
    padding: 20px;
}

.logo-image {
    display: none;
}

.logo-with-text-image {
    position: fixed;
    left: -30px;
    height: 133px;
    margin-right: 5px;
    z-index: 1000;
}

/* .logo-text {
    font-size: 20px;
    font-weight: bold;
    position: relative;
    bottom: 2px;
} */

.close-view-all-events {
    position: absolute;
    right: 40px;
    color: white;
    font-size: 16px;
    white-space: nowrap;
    display: inline;
    cursor: pointer;
}

.search-bar-container {
    max-width: 800px;
    flex-grow: 1;
    margin-right: 10px;
    margin-left: 10%;
}

.search-input {
    border-color: #41576D !important;
    background-color: #41576D !important;
}

.search-input::placeholder {
    color: white !important;
}

.left-search-icon {
    border-color: #41576D !important;
    border-right-color: gray !important;
    border-right-width: 0.1em !important;
}

.right-search-icon {
    border-left-width: 0.1em !important;
    cursor: pointer;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-right: 1%;
    margin-left: 2%;
}

.newsletter-button {
    position: fixed;
    bottom: 70px;
    /* Adjust spacing from bottom */
    right: 0px;
    transform: translateX(-50%);
    z-index: 10000;
    background-color: white;
    color: black;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    border-radius: 25px;
    cursor: pointer;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    transition: background 0.3s ease, transform 0.2s ease;
}

.scroll-to-top {
    position: fixed;
    bottom: 70px;
    /* Adjust spacing from bottom */
    left: 140px;
    transform: translateX(-50%);
    z-index: 10000;
    background-color: white;
    color: black;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    border-radius: 25px;
    cursor: pointer;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    transition: background 0.3s ease, transform 0.2s ease;
}

.newsletter-button:hover {
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
}

.newsletter-button:active {
    transform: translateX(-50%) scale(0.95);
}

@media (max-width: 1000px) {
    .logo-image {
        position: absolute;
        left: -30px;
        height: 133px;
        margin-right: 5px;
    }

    .logo-with-text-image {
        display: block;
    }
}

@media (max-width: 1511px) {
    .logo-image {
        position: absolute;
        left: -30px;
        height: 133px;
        margin-right: 5px;
        display: none;
    }

    .logo-with-text-image {
        display: block;
    }
}

@media (min-width: 770px) {
    .logo-image {
        position: absolute;
        left: -30px;
        height: 133px;
        margin-right: 5px;
        display: none;
    }

    .logo-with-text-image {
        display: block;
    }

    .search-events-container {
        position: relative;
        left: 100px;
    }
}
</style>